/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Component, Injector } from '@angular/core';
import { type Command, type PromptConfigFull, DeleteAbstract } from '@dm/core';
import { type NFSShare } from 'app/common/types/mo';

import { NfsShareStrService } from '../nfs-share-str.service';
import { NfsShareService } from './../nfs-share.service';

@Component({
    selector: 'app-delete-nfs-share',
    templateUrl: './delete-nfs-share.component.html',
    styleUrls: ['./delete-nfs-share.component.scss'],
})
export class DeleteNfsShareComponent extends DeleteAbstract<NFSShare> {
    i18n = this.str.i18n;

    constructor(
        injector: Injector,
        private str: NfsShareStrService,
        private nfsService: NfsShareService,
    ) {
        super(injector);
    }

    initTable(): void {
        this.tableColumnDefs = [
            {
                field: 'SHAREPATH',
                header: this.i18n.label.share_path,
                className: ['table-cell-text-pre'],
            },
            {
                field: 'ID',
                header: this.i18n.label.id,
            },
        ];
    }

    prompt(): PromptConfigFull[] {
        const prompts: PromptConfigFull[] = [
            {
                id: 'prompt-delete-nfs-share-highRisk-deleteNFS',
                canHidden: true,
                opType: 'warning',
                title: this.i18n.title.deleteShare,
                content: this.i18n.highRisk.deleteNFS,
                templateRef: this.tableTemplate,
                width: 700,
            },
        ];

        return prompts;
    }

    buildCmds(): Command[] {
        const cmds: Command[] = this.dataList.map((a) => ({
            name: this.i18n.rest.deleteNFS,
            nameParams: [a.SHAREPATH],
            action: this.nfsService.delete(a.ID, a.vstoreId),
        }));

        return cmds;
    }
}
